import React from "react";
import * as styles from "./resources.module.css";
// @ts-ignore
import epk from "../../resources/epk.jpg";

const resources = () => (
  <section id="resources" className="section-wrapper">
    <h2 className="section-title">
      <a href="#resources">Resources</a>
    </h2>
    <div>
      <a className={styles.resourceButtonLink} href={epk} download="epk.jpg">
        EPK
      </a>
      <a className={styles.resourceButtonLink}>Rider</a>
    </div>
  </section>
);

export default resources;
